import API from "Services/Api";

export const getResultStatus = async (filter: string) => {
  const response = await API.get(`/reports/consult?${filter}`);

  return response.data;
};
